module.exports = __webpack_public_path__ + "img/ICertus-Logo.d8336ed3.png";